var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49926 4.81963H0.481392C0.347454 4.81963 0.238926 4.92821 0.238926 5.0621V14.7572C0.238926 14.8912 0.347454 14.9997 0.481392 14.9997H3.49926C3.6332 14.9997 3.74173 14.8912 3.74173 14.7572V5.0621C3.74173 4.92821 3.6332 4.81963 3.49926 4.81963Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99142 0C0.89334 0 0 0.89237 0 1.98924C0 3.08659 0.89334 3.9793 1.99142 3.9793C3.08862 3.9793 3.98124 3.08654 3.98124 1.98924C3.98128 0.89237 3.08862 0 1.99142 0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1755 4.57904C9.96337 4.57904 9.06737 5.1001 8.5239 5.69215V5.06247C8.5239 4.92858 8.41537 4.82 8.28144 4.82H5.3913C5.25736 4.82 5.14883 4.92858 5.14883 5.06247V14.7576C5.14883 14.8915 5.25736 15.0001 5.3913 15.0001H8.40257C8.53651 15.0001 8.64504 14.8915 8.64504 14.7576V9.96075C8.64504 8.34433 9.0841 7.7146 10.2109 7.7146C11.438 7.7146 11.5356 8.72413 11.5356 10.0439V14.7576C11.5356 14.8916 11.6441 15.0001 11.778 15.0001H14.7904C14.9244 15.0001 15.0329 14.8916 15.0329 14.7576V9.4397C15.0329 7.03613 14.5746 4.57904 11.1755 4.57904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.6494fab21644d3527e9a96827e34e271.svg";
export { ForwardRef as ReactComponent };